export enum AffiliateEvent {
  CREATED = 'AFFILIATE_CREATED',
  ACTIVATED = 'AFFILIATE_ACTIVATED',
}
